import { SYS_SIZE_FIXED_300 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledColumnContainer = styled.div`
	display: flex;
	gap: 16px;

	img {
		width: 100%;
	}

	div {
		flex: 1;
		.total-price {
			color: ${({ theme }) => theme.sys.color.text.headline.default};
			font-weight: bold;
		}
	}
	.features-title {
		color: ${({ theme }) => theme.sys.color.text.headline.default};
		margin-bottom: ${SYS_SIZE_FIXED_300};
	}
	p {
		word-break: break-word;
	}
`;
